
import React from 'react';
import Layout from '@/components/Layout/Layout';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar } from 'lucide-react';
import DueDateCalculator from '@/components/SpecialCalculators/PregnancyCalculators/DueDateCalculator';

const DueDateCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/special" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to Special Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Due Date Calculator</h1>
          <p className="text-gray-600 mb-6">
            Estimate your baby's arrival date using different calculation methods.
          </p>
        </div>
        
        <div className="mb-8">
          <DueDateCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Due Date Calculation</h2>
          <p>
            Your due date, also called the estimated date of delivery (EDD), is an estimate of when your baby 
            will be born. It gives you a general timeframe to prepare for the arrival of your baby.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Different Calculation Methods</h3>
          
          <h4 className="font-medium mt-4 mb-1">Last Menstrual Period (LMP) Method</h4>
          <p>
            The most common method uses the first day of your last menstrual period. This is Naegele's rule, 
            which adds 280 days (40 weeks) to the first day of your LMP. This method assumes a 28-day cycle 
            with ovulation occurring on day 14.
          </p>
          
          <h4 className="font-medium mt-4 mb-1">Conception Date Method</h4>
          <p>
            If you know when conception occurred, your due date is approximately 266 days (38 weeks) 
            from that date.
          </p>
          
          <h4 className="font-medium mt-4 mb-1">IVF Transfer Date Method</h4>
          <p>
            For IVF pregnancies, the due date is calculated based on the age of the embryo at transfer 
            and the date of the transfer. For a 3-day embryo transfer, the due date is 263 days after 
            transfer. For a 5-day blastocyst transfer, it's 261 days after transfer.
          </p>
          
          <h4 className="font-medium mt-4 mb-1">Ultrasound Method</h4>
          <p>
            Early ultrasound measurements can provide a more accurate estimate of gestational age, 
            especially if you're unsure about your LMP or have irregular cycles.
          </p>
          
          <div className="bg-blue-50 p-4 rounded-md mt-6">
            <div className="flex items-center mb-2">
              <Calendar className="h-5 w-5 text-blue-600 mr-2" />
              <h3 className="text-lg font-medium text-blue-800">Important to Remember</h3>
            </div>
            <p className="text-blue-800">
              Only about 4-5% of babies are born on their exact due date. Most babies are born within 
              two weeks before or after this date. Your due date is an estimate, not a deadline.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DueDateCalculatorPage;
